import React from "react";
import servicesProject from "assets/services-image/services_project.png";

const Project = () => {
  return (<div className="services-section mobile-reverse--image">
    <div className="services-section--image">
      <img src={servicesProject} alt="Project"/>
    </div>
    <div className="services-section--content">
      <h2>Project</h2>
      <ul>
        <li>
          <p><b>Project Management:</b> Track project timelines, milestones, and tasks.</p>
        </li>
        <li>
          <p><b>Resource Allocation:</b> Manage resources assigned to projects.</p>
        </li>
        <li>
          <p><b>Budget Tracking:</b> Monitor project budgets and expenditures.</p>
        </li>
        <li>
          <p><b>Progress Reports:</b> Generate reports on project progress and status.</p>
        </li>
      </ul>
    </div>
  </div>);
};

export default Project;
